import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "railRoute__info" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "railRoute__info__ico icoSeat" }, null, -1)
const _hoisted_3 = { class: "railRoute__info__type" }
const _hoisted_4 = { class: "railRoute__info__price" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("ul", null, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.ckTrainListReferences, (carriage) => {
        return (_openBlock(), _createBlock("li", {
          key: carriage.categoryCarriage
        }, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, _toDisplayString(carriage.categoryCarriagePrinted
            ? carriage.categoryCarriagePrinted
            : carriage.categoryCarriage), 1),
          _createVNode("a", {
            href: "#",
            class: "railRoute__info__count",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(carriage.cvTrainListReference.countFreePlacesWithoutTopAndBottom) + " мест", 1),
          _createVNode("span", _hoisted_4, "от " + _toDisplayString(carriage.costTicket) + " ₽", 1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}